module.exports = __webpack_public_path__ + "static/media/unsync.5a0158df.svg";